export const NARRATIVE_COMMUNITY_LIST_PAGE_SIZE = 9;
export const NARRATIVE_COMMUNITY_AFTER_QUERY_PARAM = 'after';
export const NARRATIVE_COMMUNITY_BEFORE_QUERY_PARAM = 'before';
